import React, { useState, useEffect } from "react";
import profileimg from "../assets/img/profileimg.png";
import Playlist from "./Playlist";

export default function Profile() {
  const [currentPage, setCurrentPage] = useState("Wallet");
  return (
    <div className="profile-wrapper">
      <div
        className="price"
        style={{
          marginTop: "78px",
          fontSize: "12px",
          fontFamily: "sans-serif",
        }}
      >
        <div>
          <div style={{ marginBottom: "4px" }}> 1 Music = $USD 0.452</div>
          <div> 1 BNB = $USD 0.452 </div>
        </div>
      </div>
      <div className="profile-card">
        <div className="profile-card-content">
          <div className="image-content">
            <img
              style={{ width: "80px", marginBottom: "10px" }}
              src={profileimg}
              alt="no img"
            />
            <div className="profile_name">Jessic Doe</div>
          </div>
          <div className="profile-card-right">
            <div className="profile-content">
              <div className="profile-link">
                https://musette.digital/jessica_doe
              </div>
              <div style={{ color: "#B0A39E", width: "80%", margin: "auto" }}>
                A wholesome farm owner in Montana. Upcoming concert solo show in
                Germany
              </div>
            </div>

            <div className="social-icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32.136"
                height="26.483"
                viewBox="0 0 32.136 26.483"
              >
                <path
                  id="Vector"
                  d="M13.123,26.483c-3.954,0-9.339-.94-12.537-5.421a3.017,3.017,0,0,1-.245-3.181,3.094,3.094,0,0,1,2.749-1.7l.318,0h.016a14.514,14.514,0,0,1-2.8-7.795,10.714,10.714,0,0,1,.889-4.973A2.991,2.991,0,0,1,4.3,1.605a3.1,3.1,0,0,1,2.45,1.169,12.9,12.9,0,0,0,4.009,3.1,14.885,14.885,0,0,0,2.358.981,9.822,9.822,0,0,1,.408-1.691,7.391,7.391,0,0,1,2.557-3.61A8.355,8.355,0,0,1,21.216,0a11.141,11.141,0,0,1,3.334.585,10.9,10.9,0,0,1,1.695.7l2.19-.438a3.21,3.21,0,0,1,.628-.063,3.093,3.093,0,0,1,2.742,4.475L30.148,8.579A15.354,15.354,0,0,1,26.269,20.7,17.562,17.562,0,0,1,13.123,26.483ZM4.325,4.544a.143.143,0,0,0-.131.084,9.571,9.571,0,0,0,.312,7.57,9.434,9.434,0,0,0,5.371,5.363.15.15,0,0,1,.1.128.137.137,0,0,1-.069.136c-2.2,1.29-5.672,1.3-6.811,1.3a.143.143,0,0,0-.13.078.14.14,0,0,0,.01.148,9.005,9.005,0,0,0,3.51,2.893,15.382,15.382,0,0,0,6.633,1.3A14.484,14.484,0,0,0,24.3,18.471a12.8,12.8,0,0,0,2.538-4.77,12.35,12.35,0,0,0,.266-5.56.158.158,0,0,1,.013-.093l2.051-4.1a.148.148,0,0,0-.131-.213.15.15,0,0,0-.03,0L25.707,4.4l-.029,0a.156.156,0,0,1-.105-.041,8.129,8.129,0,0,0-4.358-1.418A5.026,5.026,0,0,0,17.2,4.517c-1.591,1.855-1.29,4.76-1.16,5.606a.152.152,0,0,1-.034.123.148.148,0,0,1-.113.052A16.745,16.745,0,0,1,4.441,4.6.147.147,0,0,0,4.325,4.544Z"
                  transform="translate(0)"
                  fill="#b0a39e"
                />
              </svg>

              <svg
                id="Icons_Instagram_Line"
                data-name="Icons/Instagram/Line"
                xmlns="http://www.w3.org/2000/svg"
                width="35.31"
                height="35.31"
                viewBox="0 0 35.31 35.31"
              >
                <path
                  id="Vector"
                  d="M20.6,29.425H8.828A8.837,8.837,0,0,1,0,20.6V8.828A8.838,8.838,0,0,1,8.828,0H20.6a8.837,8.837,0,0,1,8.827,8.828V20.6A8.837,8.837,0,0,1,20.6,29.425ZM8.828,2.942A5.892,5.892,0,0,0,2.942,8.828V20.6a5.892,5.892,0,0,0,5.886,5.884H20.6A5.891,5.891,0,0,0,26.483,20.6V8.828A5.892,5.892,0,0,0,20.6,2.942Z"
                  transform="translate(2.943 2.943)"
                  fill="#b0a39e"
                />
                <path
                  id="Vector-2"
                  data-name="Vector"
                  d="M2.943,1.471A1.471,1.471,0,1,0,1.471,2.943,1.471,1.471,0,0,0,2.943,1.471Z"
                  transform="translate(23.54 8.828)"
                  fill="#b0a39e"
                />
                <path
                  id="Vector-3"
                  data-name="Vector"
                  d="M7.357,14.712a7.356,7.356,0,1,1,7.356-7.356A7.365,7.365,0,0,1,7.357,14.712Zm0-11.77A4.414,4.414,0,1,0,11.77,7.357,4.42,4.42,0,0,0,7.357,2.942Z"
                  transform="translate(10.299 10.299)"
                  fill="#b0a39e"
                />
              </svg>

              <svg
                id="Icons_Facebook_Line"
                data-name="Icons/Facebook/Line"
                xmlns="http://www.w3.org/2000/svg"
                width="35.31"
                height="35.31"
                viewBox="0 0 35.31 35.31"
              >
                <path
                  id="Vector"
                  d="M14.712,29.425A14.712,14.712,0,1,1,29.425,14.712,14.729,14.729,0,0,1,14.712,29.425Zm0-26.483a11.77,11.77,0,1,0,11.77,11.77A11.784,11.784,0,0,0,14.712,2.942Z"
                  transform="translate(2.943 2.943)"
                  fill="#b0a39e"
                />
                <path
                  id="Vector-2"
                  data-name="Vector"
                  d="M7.356,2.943H8.828A1.471,1.471,0,1,0,8.828,0H7.356A4.414,4.414,0,0,0,2.943,4.414V7.356H1.471a1.471,1.471,0,1,0,0,2.943H2.943v8.828a1.471,1.471,0,0,0,2.943,0V10.3H8.828a1.471,1.471,0,1,0,0-2.943H5.885V4.414A1.471,1.471,0,0,1,7.356,2.943Z"
                  transform="translate(11.77 10.299)"
                  fill="#b0a39e"
                />
              </svg>
            </div>
            <div
              className="playmusic-card-buttons profile-card-buttons"
              style={{ marginTop: "12px" }}
            >
              <div className="nft-buttons profile-card-buttons-inside">
                <div style={{ width: "50px" }}>Indie</div>
                <div style={{ width: "50px" }}>Pop</div>
                <div style={{ width: "50px" }}>r&B</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="profile-main">
        <div className="profile-main-links">
          <div className="profile-card-awards">
            <div
              style={{
                borderBottom: "1px solid #D3C7C3",
                marginBottom: "10px",
                paddingBottom: "4px",
              }}
            >
              ACCOLADES AND AWARDS
            </div>

            <div style={{ fontSize: "12px" }}>
              International Songwriting Competition
            </div>
          </div>

          <div className="profile-links-pages">
            <div className="each-profile-page">
              <div
                onClick={() => setCurrentPage("Wallet")}
                className={currentPage === "Wallet" ? "current-page" : ""}
              >
                WALLET
              </div>
              <div
                onClick={() => setCurrentPage("Playlist")}
                className={currentPage === "Playlist" ? "current-page" : ""}
              >
                MY PLAYLIST
              </div>
              <div
                onClick={() => setCurrentPage("NFT")}
                className={currentPage === "NFT" ? "current-page" : ""}
              >
                MY NFT
              </div>
              <div
                onClick={() => setCurrentPage("Collection")}
                className={currentPage === "Collection" ? "current-page" : ""}
              >
                MY COLLECTION
              </div>
            </div>

            <div className="profile-page-content-wrapper">sdkjfn</div>
          </div>
        </div>
      </div>
    </div>
  );
}
